import { createReducer } from 'typesafe-actions';

import { setMode } from './actions';
import { ThemeModeType } from '@make-software/cspr-design';

// export type Mode = 'dark' | 'light';

export type State = {
  mode: ThemeModeType;
};
const initialState: State = {
  mode: ThemeModeType.light,
};

export default createReducer(initialState).handleAction(
  setMode,
  (state, { payload }): State => ({
    ...state,
    mode: payload,
  })
);
